import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation GenerateMosaicPage(
    $prompt: String!
    $zoneId: ID!
    $tenantId: ID!
    $data: String!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          generateAiPage(prompt: $prompt, data: $data)
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.GenerateMosaicPageMutation,
  undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'mosaicDev',
      graphql.transformers.OUT.select(
        'generateAiPage',
        graphql.transformers.OUT.always(undefined),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.GenerateMosaicPageMutation,
  undefined,
  graphql.schema.GenerateMosaicPageMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
